import { isNewOrder } from '../../hooks/use-prescriber-orders';
import type { BasicPrescriberOrderFragment } from '../cabinet/prescriber-orders';

export const hasPriorPrescriptions = (
    orders?: BasicPrescriberOrderFragment[]
) => !!orders?.some((order) => !isNewOrder(order));
